// Each character can be up to 4 bytes in DDB. The below limit means that the max size of a record in DDB is 16KB.
// The largest possible read will accordingly return 1.6MB for 100 records.
// DDB operations have a limit of 16MB. This limit helps us stay well below it.
export const MAX_TEXT_LENGTH = 4000;

/* Restricts the number of templates that a user can get in a single request */
export const GET_TEMPLATES_MAX_TEMPLATE_IDS = 5;
export const GET_TEMPLATES_MAX_METADATA_FILTERS = 5;

/* Share APIs reject requests that specify too many permissions to add/remove */
export const SHARE_MAX_PERMISSIONS = 10;

/* Max number of descriptors that can be associated with any entity */
export const MAX_DESCRIPTORS_IN_ENTITY = 10;

/* Maximum length of a namespace and key for a default */
export const MAX_DEFAULT_NAMESPACE_LENGTH = 255;
export const MAX_DEFAULT_KEY_LENGTH = 255;
